/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {updateItem} from '../utils/dataByLineUtils';
import {downloadFile} from '../../common/util/file';
export const INITIAL_STATE = {
  'loading': false,
  'modelsMenu': null,
  'modelsSelector': null,
  'modelsByLine': [],
  'notification': null,
  'notificationCount': null,
  'updateTable': false,
  'excelData': [],
  'filters': {
    'master': null,
    'dealer': null,
    'destiny': null,
    'sfx': null,
    'group': null,
    'type': null,
    'url': '',
  },
};

export const vehiclesInventory = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_MODELS_MENU]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MODELS_MENU]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'modelsMenu': [...action.response.data],
        'modelsSelector': action.response.flag === 'all' ? [...action.response.data] : state.modelsSelector,
      });
    },
    [ActionTypes.FETCH_MODELS_MENU_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modelsMenu': null,
    }),

    [ActionTypes.FETCHING_MODELS_BY_LINE_MENU]: (state, action) => ({
      ...state,
      'loading': true,
      'modelsByLine': [],
    }),
    [ActionTypes.FETCHED_MODELS_BY_LINE_MENU]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'modelsByLine': [...action.response.data],
        'updateTable': !state.updateTable,

      });
    },
    [ActionTypes.FETCH_MODELS_MENU_BY_LINE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modelsByLine': null,
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.UPDATE_TABLE_INVENTORY]: (state, action) => ({
      ...state,
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.FETCHING_UPDATE_MODELS_BY_LINE_MENU]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_UPDATE_MODELS_BY_LINE_MENU]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'modelsByLine': Array.isArray(action.response.data) ? action.response.data : ([
          ...updateItem(state.modelsByLine, action.response.data, ['orderNumber', 'line']),
        ] || state.tempOrders),
        'updateTable': !state.updateTable,
      });
    },
    [ActionTypes.FETCH_UPDATE_MODELS_MENU_BY_LINE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modelsByLine': null,
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.SET_FILTER_INVENTORY]: (state, action) => ({
      ...state,
      'filters': {...action.payload},
    }),
    [ActionTypes.SET_EXCEL_DATA_INVENTORY]: (state, action) => ({
      ...state,
      'excelData': [...action.payload],
    }),
    [ActionTypes.FETCHING_NOTIFICATION_PRIORIZATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_NOTIFICATION_PRIORIZATION]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'notification': [...action.response.data],
        'notificationCount': action.response.count,
      });
    },
    [ActionTypes.FETCH_NOTIFICATION_PRIORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'notification': null,
      'notificationCount': 0,
    }),
    [ActionTypes.FETCHING_UPDATE_NOTIFICATION_PRIORIZATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_UPDATE_NOTIFICATION_PRIORIZATION]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'notification': [...action.response.data],
        'notificationCount': action.response.count,
      });
    },
    [ActionTypes.FETCH_UPDATE_NOTIFICATION_PRIORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_TRANSIT_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TRANSIT_REPORT]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.FETCH_TRANSIT_REPORT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
